/**
 * @since 2025-02-19
 * @author Francesco Parrella
 * @maintainer Francesco Parrella
 * @copyright AlgoTraders, All rights reserved
 */

import "./DialogConfirmJobAction.scss";

const DialogConfirmJobAction = ({
  listJobs,
  actionName,
  onActionConfirmed,
  onActionCanceled,
}) => {
  const confirmAction = () => {
    onActionConfirmed();
  };

  const cancelConfirm = () => {
    onActionCanceled();
  };

  return (
    <div className="dialog-confirm-action">
      <div className="confirm-dialog-content">
        <p>
          Do you want to <b>{actionName}</b> the following jobs?
        </p>
        <div className="job-list">
          <ul>
            {listJobs.map((job, index) => (
              <li key={index}>
                {index + 1}. {job.id}
              </li>
            ))}
          </ul>
        </div>
        <div className="confirm-dialog-buttons">
          <button className="confirm-button" onClick={confirmAction}>
            Yes
          </button>
          <button className="cancel-button" onClick={cancelConfirm}>
            No
          </button>
        </div>
      </div>
    </div>
  );
};

export default DialogConfirmJobAction;
